<template>
  <div>
    <nav
      class="navbar navbar-expand-md navbar-light bg-white shadow-sm fixed-top"
    >
      <div class="container">
        <a class="navbar-brand" href="#">
          {{ $page.props.config.app_name }}
        </a>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#main-app-nav"
          aria-controls="main-app-nav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="main-app-nav">
          <!-- Left Side Of Navbar -->
          <ul class="navbar-nav mr-auto">
            <li
              v-for="user_route in $page.props.routes"
              :key="user_route.name"
              class="nav-item"
              :class="{ dropdown: user_route.sub_routes, active: route().current(user_route.match) }"
            >
              <a
                v-if="user_route.sub_routes"
                class="nav-link dropdown-toggle"
                :class="{ active: route().current(user_route.match) }"
                href="#"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {{ user_route.label }}
              </a>
              <div v-if="user_route.sub_routes" class="dropdown-menu">
                <inertia-link
                  v-for="sub_route in user_route.sub_routes"
                  :key="sub_route.name"
                  class="dropdown-item"
                  :href="route(sub_route.name)"
                >
                  {{ sub_route.label }}
                </inertia-link>
              </div>
              <inertia-link
                v-else
                class="nav-link"
                :class="{ active: route().current(user_route.match) }"
                :href="route(user_route.name)"
              >
                {{ user_route.label }}
              </inertia-link>
            </li>
          </ul>

          <!-- Right Side Of Navbar -->
          <ul class="navbar-nav ml-auto">
            <!-- Authentication Links -->

            <li class="nav-item dropdown">
              <a
                id="navbarDropdown"
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {{ $page.props.authUser.first_name }}
              </a>

              <div
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="navbarDropdown"
              >
                <a
                  class="dropdown-item"
                  v-bind:href="$page.props.logoutLink"
                  onclick="event.preventDefault(); document.getElementById('logout-form').submit();"
                >
                  Logout
                </a>

                <form
                  id="logout-form"
                  v-bind:action="$page.props.logoutLink"
                  method="POST"
                  class="d-none"
                >
                  <input
                    type="hidden"
                    name="_token"
                    v-bind:value="$page.props.csrf_token"
                  />
                </form>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <main class="container mt-5">
      <slot />
    </main>
    <footer class="footer">
      <div class="container text-right">
        <span class="text-muted">
          <!-- {{ $page.props.config.app_name }} {{ $page.props.config.version }} -->
        </span>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  props: {},
  // watch: {
  //   title: {
  //     immediate: true,
  //     handler(title) {
  //       if(title) document.title = title;
  //     },
  //   },
  // },
};
</script>